import { AppEnv } from '@environments/environment.model';

export const environment: AppEnv = {
  domain: 'dev.hopla.ch',
  stack: 'dev',
  appName: 'hopla',
  contactEmail: 'info@hopla.ch',
  baseUrl: 'https://dev.hopla.ch',
  apiUrl: 'https://svc.dev.hopla.ch/api',
  umami: {
    websiteId: '2369d18b-aef9-42ac-a8fa-3ea9a49995bd',
    url: 'https://analytics.hopla.ch'
  }
};
